import auth from "domain/core/auth/actions";
import app from "./app/actions";
export default {
  auth,
  app,
};
